import { render, staticRenderFns } from "./ActionSwitch.vue?vue&type=template&id=1c7e17c8&"
import script from "./ActionSwitch.vue?vue&type=script&lang=js&"
export * from "./ActionSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ActionSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports